import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IAuthApisRefreshAuthTokenResponse } from '../../../entity/interface/iAuthApis';
import { IAuthRepository } from '../../repositories/interfaces/iAuthRepository';
import { remove } from '@intigral/utils/lib/browser-storage/localStorage';
import { STORE_NAME } from '@intigral/constant';

export interface IRefreshAuthTokenUseCase {
    execute(
        username: string,
        authToken: string,
        identityToken: string,
        authSign: string,
        apiToken: { [key: string]: string }
    ): Promise<IAuthApisRefreshAuthTokenResponse['data']>;
}

export class RefreshAuthTokenUseCase implements IRefreshAuthTokenUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get authRepo(): IAuthRepository {
        return container.resolve<IAuthRepository>(DI.REPOSITORIES.IAuthRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(
        username: string,
        authToken: string,
        identityToken: string,
        authSign: string,
        apiToken: { [key: string]: string }
    ): Promise<IAuthApisRefreshAuthTokenResponse['data']> {
        try {
            const response = await this.authRepo.refreshAuthToken(
                username,
                authToken,
                identityToken,
                authSign,
                apiToken
            );
            return response.data;
        } catch (err: any) {
            console.error(err);
            if (err?.data?.status === 403) {
                remove(STORE_NAME.API_TOKEN);
            }
            throw err;
        }
    }
}
